import { ChartLine, DatabaseZapIcon } from "lucide-react";
import { AiOutlineOpenAI, AiOutlineRobot } from "react-icons/ai";
import {
  BiBitcoin,
  BiLineChart,
  BiLogoNodejs,
  BiLogoPostgresql,
  BiLogoTypescript,
  BiMovie,
  BiWorld,
} from "react-icons/bi";
import { TbBrandBooking } from "react-icons/tb";
import { DiRedis } from "react-icons/di";
import {
  FaCity,
  FaGamepad,
  FaPython,
  FaQuran,
  FaReact,
  FaSlack,
  FaSpotify,
} from "react-icons/fa";
import {
  FaAws,
  FaBitbucket,
  FaBitcoin,
  FaRobot,
  FaShopify,
} from "react-icons/fa6";
import { IoRestaurant } from "react-icons/io5";
import { MdMovie, MdOutlineQueryBuilder } from "react-icons/md";
import { RiNextjsFill, RiNotionFill } from "react-icons/ri";
import {
  SiBitcoin,
  SiChatbot,
  SiClerk,
  SiElasticsearch,
  SiGooglecloud,
  SiGooglemaps,
  SiKoa,
  SiLangchain,
  SiMongodb,
  SiMui,
  SiNextdotjs,
  SiOpenai,
  SiPaypal,
  SiPrisma,
  SiShadcnui,
  SiStripe,
  SiSystem76,
  SiTailwindcss,
  SiWalletconnect,
  SiWeb3Dotjs,
} from "react-icons/si";
import { TbBrandDisney, TbBrandFramerMotion, TbTicTac } from "react-icons/tb";
import { TfiLayoutMediaOverlay } from "react-icons/tfi";
import { TiWeatherCloudy } from "react-icons/ti";
import { VscAzure } from "react-icons/vsc";
import { EducationElement, ProjectMetadata } from "./types";

export const educations: Record<
  "engineering" | "preparatory" | "baccalaureat",
  EducationElement
> = {
  engineering: {
    institution: "Faculty of Sciences of Tunis El Manar (FST)",
    degree: "Computer Science Engineering",
    description:
      "During my engineering studies, I explored a diverse range of subjects including software development, system design and architecture, data structures and algorithms, web and mobile programming, database management, cloud computing, and virtualization. I developed proficiency in multiple programming languages including JavaScript, TypeScript, Python, C#, Java, and PHP. My academic projects spanned various domains utilizing frameworks such as Spring Boot, ASP.NET, Angular, Django, and Java Android. Additionally, I earned professional certifications including AWS Academy and Cisco Network CCNA 1 and 2.",
    // 'Studied Software Engineering studied Web and mobile Development I gained proficiency in multiple programming languages and investigated others, such as JavaScript,TypeScript, Python, C#, Java, and PHP. Additionally, I undertook projects across diverse topics utilizing frameworks like Spring Boot, Asp .Net, Angular, django and java android. I also earned certifications including AWS academy and cisco network CCNA 1 and 2'
    duration: "September 2019 - September 2022",
    link: "https://fst.rnu.tn/fr",
    logo: "https://upload.wikimedia.org/wikipedia/fr/thumb/8/8d/FSTLOGO.svg/1200px-FSTLOGO.svg.png",
  },
  preparatory: {
    institution: "Faculty of Sciences of Tunis El Manar (FST)",
    degree: "Preparatory Program - Mathematics and Physics",
    duration: "September 2016 - September 2018",
    description:
      "Active an intensive preparatory program in mathematics and physics designed to prepare students for engineering school entrance examinations. The curriculum provided comprehensive training in mathematics, physics, chemistry, and other scientific disciplines. I successfully passed the competitive entrance examination for engineering schools, earning an honorable degree with distinction in mathematics and software engineering.",
    link: "https://fst.rnu.tn/fr",
    logo: "https://upload.wikimedia.org/wikipedia/fr/thumb/8/8d/FSTLOGO.svg/1200px-FSTLOGO.svg.png",
    about:
      "The preparatory program provides intensive training in mathematics, physics, chemistry, and other scientific subjects to prepare students for the competitive entrance exams of engineering schools (Grandes Écoles). The program typically spans two years, following the French CPGE (Classes Préparatoires aux Grandes Écoles) model.",
  },
  baccalaureat: {
    institution: "High School National Diploma",
    description:
      "Successfully completed the national baccalaureate examination in mathematics with distinction, achieving an excellent academic performance.",
    degree: "Bachelor's Degree in Mathematics",
    duration: "September 2014 - June 2015",
    link: "https://www.ecoles.com.tn/etablissements/secondaire/lycee-mourouj-1",
  },
};

// export const aboutMe = {
//   title: "About Me",
//   description: aboutTexts.join("\n"),
//   info: [
//     {
//       fieldName: "Name",
//       fieldValue: "Hamza Missaoui",
//     },
//     {
//       fieldName: "Phone",
//       fieldValue: "+216 56 06 22 66",
//     },
//     {
//       fieldName: "Email",
//       fieldValue: "hamza.missaoui47@gmail.com / hamzashadow47@gmail.com",
//     },
//     {
//       fieldName: "Languages",
//       fieldValue: "English, French, Arabic",
//     },
//     {
//       fieldName: "Nationality",
//       fieldValue: "Tunisian",
//     },
//     {
//       fieldName: "Experience",
//       fieldValue: "4+ Years",
//     },
//     {
//       fieldName: "Freelance",
//       fieldValue: "Available",
//     },
//     {
//       // fieldName: 'Employment Type',
//       fieldName: "Contact or Full Time Contrat",
//       fieldValue: "Available",
//     },
//     {
//       fieldName: "LinkedIn",
//       fieldValue: "https://www.linkedin.com/in/hamza-missewi/",
//     },
//     {
//       fieldName: "GitHub",
//       fieldValue: "https://github.com/hamzaMissewi",
//     },
//     {
//       fieldName: "HackerRank",
//       fieldValue: "https://www.hackerrank.com/profile/hamza_missaoui47",
//     },
//   ],
// };

export enum ProjectCategory {
  "frontend_project" = "Frontend Project",
  "next_js_application" = "Next Js Application",
  "fullstack_project" = "Fullstack Project",
}

export const projectsData: ProjectMetadata[] = [
  {
    // id: 1,
    title: "B2b Alive Ltd",
    // createdAt: "01-2022",
    createdAt: new Date(2022, 0, 1), // January 2022
    duration: "October 2022 - January 2025",
    category: ProjectCategory.fullstack_project,
    icon: TfiLayoutMediaOverlay,
    featured: true,
    status: "Archived",
    description:
      "Developed and maintained important features for the application within the advertising and visual content display sector, utilizing a full-stack approach encompassing front-end and back-end development. Key contributions include: Front-End Development (React, TypeScript): Designed and implemented responsive, interactive user and administrator interfaces using React and TypeScript. Integrated with various cloud services (AWS, Google Cloud, Azure) including AI/ML APIs (OpenAI, Google Gemini, Azure Vision) for image recognition, translation, and intelligent recommendations. Back-End Development (Node.js, GraphQL, MongoDB): Built and maintained scalable and efficient back-end services using Node.js (Express/Koa), GraphQL (Apollo Server), and MongoDB. Developed and optimized GraphQL schemas and resolvers, improving data retrieval performance. Data Management & Search: Implemented robust data management solutions using MongoDB, leveraging Elasticsearch and Algolia for optimized search and retrieval. Utilized Redis and BullMQ for caching and queue management to enhance application speed and efficiency. Media Integration & Processing: Integrated Adobe Stock and Shutter Stock APIs for media asset acquisition. Leveraged AWS services (S3, MediaConvert, IAM) for asset storage, transcoding, and video processing. Testing & Quality Assurance: Conducted thorough unit testing (Jest) and ensured robust GraphQL mutation handling for optimal HTTP request performance. Proactively identified and resolved bugs to maintain application stability.",
    live: "https://www2.b2b-alive.com",
    highlightedThumbnail: "/projects/b2b_alive/main.png",
    thumbnails: [
      "/projects/b2b_alive/maps/1.jpg",
      "/projects/b2b_alive/maps/2.jpg",
      "/projects/b2b_alive/maps/3.jpg",
      "/projects/b2b_alive/stade/1.jpg",
      "/projects/b2b_alive/stade/2.jpg",
      "/projects/b2b_alive/stade/3.jpg",
      "/projects/b2b_alive/stade/4.jpg",
      "/projects/b2b_alive/auth.png",
      "/projects/b2b_alive/new/chooseCountry.png",
      "/projects/b2b_alive/new/projectPage.png",
      "/projects/b2b_alive/new/language.png",
      "/projects/b2b_alive/new/updateLocation.png",
      "/projects/b2b_alive/remake/1.png",
      "/projects/b2b_alive/remake/2.png",
      "/projects/b2b_alive/remake/languages.png",
      "/projects/b2b_alive/remake/scenes.png",
      "/projects/b2b_alive/remake/players.png",
      "/projects/b2b_alive/remake/user.png",
      "/projects/b2b_alive/remake/user1.png",
      "/projects/b2b_alive/broadcaster/1.jpg",
      "/projects/b2b_alive/schedule/main.png",
      "/projects/b2b_alive/schedule/1.png",
      "/projects/b2b_alive/schedule/3.png",
      "/projects/b2b_alive/schedule/5.png",
      "/projects/b2b_alive/schedule/6.png",
      "/projects/b2b_alive/schedule/7.png",
      "/projects/b2b_alive/schedule/8.png",
      "/projects/b2b_alive/upload-medias/1.png",
      "/projects/b2b_alive/upload-medias/2.png",
      "/projects/b2b_alive/upload-medias/3.png",
    ],
    github: "https://github.com/hamzaMissewi/public-b2b-alive-server",
    videoUrl:
      "https://drive.google.com/file/d/1UWGLj57TG2IkxiV4MmyjrmZbBTxgPeep/view?usp=drive_link",
    techs: [
      {
        name: "ReactJS",
        icon: FaReact,
      },
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "KoaJs",
        icon: SiKoa,
      },
      {
        name: "MongoDb",
        icon: SiMongodb,
      },
      {
        name: "Redis",
        icon: DiRedis,
      },
      {
        name: "GCP",
        icon: SiGooglecloud,
      },
      {
        name: "Google Maps",
        icon: SiGooglemaps,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
      {
        name: "Elasticsearch",
        icon: SiElasticsearch,
      },
      {
        name: "Bitbucket",
        icon: FaBitbucket,
      },
      {
        name: "Microsoft Azure",
        icon: VscAzure,
      },
      {
        name: "Amazon Aws",
        icon: FaAws,
      },
      {
        name: "NodeJS",
        icon: BiLogoNodejs,
      },
      {
        name: "Material Ui",
        icon: SiMui,
      },
    ],
  },
  {
    // id: 2,
    title: "Ecommerce Platform",
    // createdAt: "09-2024",
    createdAt: new Date(2024, 9, 1), // September 2024
    category: ProjectCategory.fullstack_project,
    icon: FaShopify,
    status: "Active",
    description:
      "A full-stack e-commerce application to command and buy a variety of products in different categories with AI-powered, a chatbot and technical team assist for product recommendations, real-time inventory management, and secure payment processing.",
    // imageUrl: '/projects/ecommerce/1.png',
    featured: true,
    thumbnails: [
      "/projects/ecommerce/1.png",
      "/projects/ecommerce/2.png",
      "/projects/ecommerce/create-product.png",
      "/projects/ecommerce/home.png",
      "/projects/ecommerce/home_2.png",
      "/projects/ecommerce/product_details.png",
      "/projects/ecommerce/product_details_2.png",
      "/projects/ecommerce/success_order.png",
      "/projects/ecommerce/order_page.png",
    ],
    // NEW
    features: [
      "User authentication and profile management",
      "Product catalog with search and filtering",
      "Shopping cart and checkout process",
      "Payment processing with Stripe",
      "Order history and tracking",
      "Admin dashboard for product and order management",
      "Real-time inventory updates",
    ],
    technicalDetails:
      "The frontend is built with React and Next.js for server-side rendering and optimal performance. State management is handled with Redux, and styling is done with Tailwind CSS. The backend uses Node.js with Express, with MongoDB as the database. Authentication is implemented using JWT tokens, and payments are processed securely through Stripe's API.",
    // END NEW
    github:
      "https://github.com/hamzaMissewi/ecommerce-nextjs-sanity-app-20-11-2024",
    live: "https://hamza-missaoui-ecommerce-app.vercel.app/",
    techs: [
      {
        name: "ReactJS",
        icon: FaReact,
      },
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
    ],
  },
  {
    title: "City Management App",
    // createdAt: "08-2025",
    createdAt: new Date(2025, 8, 1),
    status: "In Progress",
    category: ProjectCategory.next_js_application,
    icon: FaCity,
    description:
      "This is an AI-powered Smart City Management Platform designed for real-time urban infrastructure monitoring and management. The application provides a comprehensive dashboard for city operations, featuring real-time data visualization, AI-powered analytics, incident management, and citizen service coordination. Built as a full-stack application with React frontend and Express.js backend, it leverages WebSocket connections for live updates and integrates multiple AI services including ChatGPT for conversational AI and predictive analytics.",
    live: "https://ai-smart-city-management.netlify.app",
    github: "https://github.com/hamzaMissewi/slack-clone",
    thumbnails: [
      "/projects/management-city/1.png",
      "/projects/management-city/2.png",
      "/projects/management-city/3.png",
    ],
    techs: [
      { name: "NextJs", icon: SiNextdotjs },
      { name: "Typescript", icon: BiLogoTypescript },
      { name: "Tailwindcss", icon: SiTailwindcss },
      { name: "Clerk", icon: SiClerk },
    ],
  },
  {
    title: "Slack Clone App",
    // createdAt: "11-2024",
    createdAt: new Date(2024, 11, 1),
    status: "In Progress",
    category: ProjectCategory.next_js_application,
    //     date: 'January 2022',
    //     techStack: 'React / Node.js / Socket.io / MongoDB',
    icon: FaSlack,
    featured: true,
    description:
      "A real-time messaging platform Cloned from Slack. Built With NextJs and Convex db and Clerk still in development. Features include direct messaging, channels, emoji reactions, and file sharing capabilities.",
    live: "https://hamza-slack-clone.vercel.app",
    github: "https://github.com/hamzaMissewi/slack-clone",
    // imageUrl: '/projects/slack/new/1.png',
    thumbnails: [
      "/projects/slack/new/1.png",
      "/projects/slack/new/2.png",
      "/projects/slack/new/3.png",
      "/projects/slack/new/4.png",
      "/projects/slack/new/5.png",
      "/projects/slack/new/6.png",
      "/projects/slack/1.png",
      "/projects/slack/2.png",
      "/projects/slack/3.png",
      "/projects/slack/4.png",
    ],
    techs: [
      { name: "NextJs", icon: SiNextdotjs },
      { name: "Typescript", icon: BiLogoTypescript },
      { name: "Tailwindcss", icon: SiTailwindcss },
      { name: "Convex", icon: DatabaseZapIcon },
      { name: "Clerk", icon: SiClerk },
    ],
  },
  {
    title: "Advanced Chatbot",
    // createdAt: "06-2025",
    createdAt: new Date(2025, 6, 1),
    description: `Hamza AI - Advanced Next.js Chatbot with Groq AI Integration
A cutting-edge AI chatbot built with Next.js 14 (App Router) and powered by Groq's ultra-fast LLM inference, enabling real-time, feature-rich conversations with customizable AI models.
Key Features:
- Multi-Model Support - Choose between Groq-powered models (Mixtral, Llama 3, Gemini) for varied responses.
- Conversation Persistence - Save, revisit, and continue chats with full history.
- Audio Playback - Listen to AI responses with text-to-speech (TTS).
- Modern UI/UX - Sleek, responsive interface with dark/light mode.
- Rate Limiting & Security - Protected API routes with JWT-based auth.`,
    icon: SiChatbot,
    // imageUrl: '/projects/chatbot/new/1.png',
    thumbnails: [
      "/projects/chatbot/new/1.png",
      "/projects/chatbot/new/2.png",
      "/projects/chatbot/new/3.png",
      "/projects/chatbot/new/4.png",
      "/projects/chatbot/new/5.png",
      "/projects/chatbot/new/6.png",
    ],
    featured: true,
    live: "https://hamza-advanced-chatbot.vercel.app",
    github: "https://github.com/hamzaMissewi/hamza-advanced-chatbot",
    techs: [
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "NextJs",
        icon: RiNextjsFill,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
      {
        name: "Groq",
        icon: SiChatbot,
      },
    ],
    status: "Active",
  },
  {
    title: "Poetry Generator App",
    category: ProjectCategory.next_js_application,
    description:
      "A Next.js application that allows user to generate poetry using ML and AI suggestions by theme, subject and short description",
    icon: SiSystem76,
    status: "Active",
    // createdAt: "05-2025",
    createdAt: new Date(2025, 5, 1),
    thumbnails: [
      "/projects/poetry-generator/1.png",
      "/projects/poetry-generator/2.png",
      "/projects/poetry-generator/3.png",
      "/projects/poetry-generator/4.png",
    ],
    live: "https://hamza-machine-learning-ai-poetry-five.vercel.app",
    github: "https://github.com/hamzaMissewi/ai-poetry-studio",
    techs: [
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "NextJs",
        icon: RiNextjsFill,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
      {
        name: "AI/ML",
        icon: FaRobot,
      },
    ],
  },
  {
    title: "Machine learning Csv files data analytics app",
    thumbnails: [
      "/projects/ml-analytics/1.png",
      "/projects/ml-analytics/2.png",
      "/projects/ml-analytics/3.png",
      "/projects/ml-analytics/4.png",
      "/projects/ml-analytics/5.png",
      "/projects/ml-analytics/6.png",
      "/projects/ml-analytics/7.png",
    ],
    github:
      "https://github.com/hamzaMissewi/machine-learning-nextjs-python-csv-analytics-app.git",
    live: "https://hamza-machine-learning-analytics-dashboard.vercel.app/",
    // createdAt: "05-2025",
    createdAt: new Date(2025, 4, 1),
    category: ProjectCategory.next_js_application,
    icon: BiLineChart,
    status: "In Progress",
    description:
      "A web application that let user upload his personal csv files for analyzing data and return results in readable different charts for analytics",
    techs: [
      {
        name: "NextJs",
        icon: SiNextdotjs,
      },
      {
        name: "Upload Api",
        // icon: SiOpenai,
      },
      {
        name: "Shadcn Charts",
        icon: BiLineChart,
      },
      {
        name: "AI/ML",
        icon: AiOutlineRobot,
      },
      {
        name: "Python",
        icon: FaPython,
      },
    ],
  },
  {
    // id: 5,
    title: "OS Config Details App",
    description:
      "A Next.js application that shows real time details about the current user and diagnostics operator system",
    icon: SiSystem76,
    status: "Active",
    // createdAt: "05-2025",
    createdAt: new Date(2025, 6, 1),
    thumbnails: [
      "/projects/os_infos/1.png",
      "/projects/os_infos/2.png",
      "/projects/os_infos/3.png",
    ],
    featured: true,
    live: "https://hamza-os-system-infos.vercel.app",
    github: "#",
    techs: [
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "NextJs",
        icon: RiNextjsFill,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
      {
        name: "Framer Motion",
        icon: TbBrandFramerMotion,
      },
    ],
  },
  {
    // id: 6,
    icon: MdMovie,
    title: "MoviesDB App",
    status: "Active",
    // createdAt: "02-2025",
    createdAt: new Date(2025, 2, 1),
    category: ProjectCategory.fullstack_project,
    description:
      "A full movies web responsive application built with NextJs, Graphql, Tmdb api, Shadcn, Tailwindcss",
    // imageUrl: '/projects/movies/1.png',
    thumbnails: [
      "/projects/movies/1.png",
      "/projects/movies/2.png",
      "/projects/movies/3.png",
      "/projects/movies/4.png",
    ],
    live: "https://hamza-movies-app.vercel.app",
    github: "https://github.com/hamzaMissewi/nextjs-graphql-movies-app-2025",
    // secondLive: 'https://quirky-wright-757726.netlify.app/',
    techs: [
      {
        name: "ReactJS",
        icon: FaReact,
      },
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
    ],
  },
  {
    // id: 7,
    title: "Weather Application",
    // createdAt: "10-2024",
    createdAt: new Date(2024, 10, 1),
    status: "In Progress",
    icon: TiWeatherCloudy,
    category: ProjectCategory.next_js_application,
    github: "https://github.com/hamzaMissewi/weather-app-shadcn-charts",
    live: "https://hamza-weather-app-charts.vercel.app",
    description:
      "A weather application that i developed with NextJs and typescript and Shadcn-ui charts to show needed informations about weather on specific location with cool charts and graphs. This project allow user to get weather details like (temperature, humidity, pressure, wind speed, clouds) depending on searched location with selecting country and city in the world",
    // imageUrl: '/projects/weather/1.png',
    thumbnails: [
      "/projects/weather/7.png",
      "/projects/weather/2.png",
      "/projects/weather/3.png",
      "/projects/weather/4.png",
      "/projects/weather/5.png",
      "/projects/weather/6.png",
      "/projects/weather/8.png",
      "/projects/weather/7.png",
    ],
    techs: [
      {
        name: "NextJs",
        icon: SiNextdotjs,
      },
      {
        name: "WeatherApi",
        icon: TiWeatherCloudy,
      },
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "Shadcn-ui",
        icon: SiShadcnui,
      },
    ],
  },
  {
    // id: 8,
    title: "Spotify Clone App",
    // createdAt: "11-2024",
    createdAt: new Date(2024, 11, 1),
    category: ProjectCategory.next_js_application,
    status: "Archived",
    icon: FaSpotify,
    description:
      "A Clone of spotify application Built With NextJs and Spotify Api",
    live: "https://hamza-spotiy-clone-app.vercel.app",
    github: "https://github.com/hamzaMissewi/spotify-clone",
    // imageUrl: '/projects/spotify/1.png',
    thumbnails: ["/projects/spotify/1.png", "/projects/spotify/favourites.png"],
    techs: [
      {
        name: "NextJs",
        icon: SiNextdotjs,
      },
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
    ],
  },
  {
    // id: 9,
    icon: RiNotionFill,
    title: "Notion Clone App",
    status: "Archived",
    // createdAt: "05-2024",
    createdAt: new Date(2024, 5, 1),
    category: ProjectCategory.frontend_project,
    description:
      "A web application represents a clone of notion ai website from initial design and front-end development to back-end implementation and deployment",
    live: "https://hamza-notion-ai-app.vercel.app",
    github: "https://github.com/hamzaMissewi/next-ts-notion-ai",
    // imageUrl: '/projects/clone_notion/home.png',
    thumbnails: [
      "/projects/clone_notion/home.png",
      "/projects/clone_notion/user_params.png",
    ],
    techs: [
      {
        name: "NextJs",
        icon: SiNextdotjs,
      },
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
    ],
  },
  {
    // id: 10,
    title: "Second Portfolio",
    icon: BiWorld,
    featured: false,
    status: "Active",
    // createdAt: "12-2024",
    createdAt: new Date(2024, 12, 1),
    category: ProjectCategory.frontend_project,
    live: "https://hamza-portfolio-pro-2025.vercel.app/",
    github: "https://github.com/hamzaMissewi/portfolio-31-12",
    description:
      "Developed this older portfolio with NextJs and typescript , this project show my career as web developer and showcase my skills and projects as senior fullstack web developer and ui/ux designer, this project has cool UI design and colors",
    // imageUrl: '/projects/portfolio/home.png',
    thumbnails: [
      "/projects/portfolio/home.png",
      "/projects/portfolio/1.png",
      "/projects/portfolio/2.png",
      "/projects/portfolio/welcome.png",
      "/projects/portfolio/ai.png",
      "/projects/portfolio/get-in-touch.png",
      "/projects/portfolio/projects.png",
    ],
    techs: [
      {
        name: "ReactJS",
        icon: FaReact,
      },
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
    ],
  },
  {
    title: "Mini Memory Game",
    // createdAt: "02-2025",
    createdAt: new Date(2025, 2, 1),
    status: "Active",
    category: ProjectCategory.next_js_application,
    // imageUrl: '/projects/mini-game/1.png',
    thumbnails: ["/projects/mini-game/1.png"],
    icon: FaGamepad,
    github: "#",
    // https://github.com/hamzaMissewi/mini-game
    description: `Built an engaging memory card game featuring:
          - Card matching gameplay
          - Score tracking system
          - Timer functionality
          - Game statistics
          - Responsive design
          - User-friendly interface`,
    live: "https://hamza-memory-mini-game.vercel.app",
    techs: [
      {
        name: "NextJs",
        icon: SiNextdotjs,
      },
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
    ],
  },
  {
    title: "Quran Web App",
    createdAt: new Date(2024, 4, 1),
    // createdAt: "04-2024",
    status: "Archived",
    category: ProjectCategory.next_js_application,
    // imageUrl: '/projects/quran/1.png',
    thumbnails: [
      "/projects/quran/1.png",
      "/projects/quran/2.png",
      "/projects/quran/3.png",
    ],
    icon: FaQuran,
    github: "https://github.com/hamzaMissewi/quran-next-clone-app",
    description:
      "Built an application to listen to quran with different reciters audio",
    live: "https://hamza-missaoui-listen-quran.vercel.app/",
    techs: [
      {
        name: "NextJs",
        icon: SiNextdotjs,
      },
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
    ],
  },
  {
    // id: 13,
    title: "Crypto Web Marketplace Next.js + Web3",
    description:
      "A crypto marketplace enabling users to buy and exchange digital assets with fiat (Stripe, PayPal) or crypto wallets, featuring real-time pricing, secure KYC, and instant settlement. A Next.js-based Web3 platform offering seamless wallet integration, token swaps, DeFi interactions, and real-time transaction tracking on the blockchain.",
    icon: FaBitcoin,
    // imageUrl: '/projects/crypto/1.png',
    thumbnails: [
      "/projects/crypto/1.png",
      "/projects/crypto/3.png",
      "/projects/crypto/4.png",
      "/projects/crypto/5.png",
      "/projects/crypto/welcome.png",
      "/projects/crypto/home.png",
    ],
    featured: true,
    status: "Active",
    github: "https://github.com/hamzaMissewi/hamza-crypto-dashboard-nextjs.git",
    techs: [
      {
        name: "NextJs",
        icon: RiNextjsFill,
      },
      {
        name: "Shadcn",
        icon: SiShadcnui,
      },
      {
        name: "Paypal payment",
        icon: SiPaypal,
      },
      {
        name: "Stripe payment",
        icon: SiStripe,
      },
      {
        name: "Web 3",
        icon: SiWeb3Dotjs,
      },
      {
        name: "Wallet connection",
        icon: SiWalletconnect,
      },
    ],
    live: "https://hamza-crypto-trading-platform.vercel.app",
    // createdAt: "03-2025",
    createdAt: new Date(2025, 3, 1),
  },
  {
    title: "Tic Tac Toe Game",
    description:
      "A Next.js-powered Tic tac toe complete game where the user can play versus another human or versus a bot, and the app will save the score between the two until he reset the score with button, with cool animation and colorful alerts",
    icon: TbTicTac,
    // imageUrl: '/projects/tic-tac/1.png',
    thumbnails: [
      "/projects/tic-tac/1.png",
      "/projects/tic-tac/2.png",
      "/projects/tic-tac/3.png",
    ],
    featured: false,
    live: "https://hamza-tic-tac-toe-game.vercel.app",
    github: "https://github.com/hamzaMissewi/tik-tak-toe-game",
    techs: [
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "NextJs",
        icon: RiNextjsFill,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
      {
        name: "Shadcn",
        icon: SiShadcnui,
      },
    ],
    status: "In Progress",
    createdAt: "05-2025",
  },
  {
    icon: MdOutlineQueryBuilder,
    title: "Resume Builder App",
    createdAt: new Date(2024, 12, 1),
    status: "Pending",
    category: ProjectCategory.next_js_application,
    // imageUrl: '/projects/resume_builder/1.png',
    thumbnails: [
      "/projects/resume_builder/1.png",
      "/projects/resume_builder/2.png",
      "/projects/resume_builder/2-black.png",
      "/projects/resume_builder/3.png",
      "/projects/resume_builder/6.png",
      "/projects/resume_builder/7.png",
      "/projects/resume_builder/8.png",
      "/projects/resume_builder/11.png",
      "/projects/resume_builder/12.png",
      "/projects/resume_builder/13.png",
      "/projects/resume_builder/14.png",
      "/projects/resume_builder/15-black.png",
      "/projects/resume_builder/16-black.png",
    ],
    github:
      "https://github.com/hamzaMissewi/nextjs-app-resume-builder-ai-nextjs",
    description:
      "Built a next js application that help user to create his resume by walking him through the steps with ease and simplicity with the possibility to use ai generator, generate and correct typed text in each section only if he upgrades his plan and buy premium features",
    live: "https://hamza-ai-resume-builder.vercel.app",
    techs: [
      {
        name: "NextJs",
        icon: SiNextdotjs,
      },
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "PostgreSql",
        icon: BiLogoPostgresql,
      },
      {
        name: "Prisma",
        icon: SiPrisma,
      },
      {
        name: "Clerk",
        icon: SiClerk,
      },
      {
        name: "Shadcn",
        icon: SiShadcnui,
      },
      {
        name: "OpenAi",
        icon: SiOpenai,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
    ],
  },
  {
    title: "AI Assistant App",
    createdAt: new Date(2024, 8, 1),
    category: ProjectCategory.next_js_application,
    icon: AiOutlineOpenAI,
    status: "Active",
    description:
      "A web application that provide IA services for user that uses advanced tools to assure the most accurate response for any question depending on the context of subject",
    // live: 'https://hamza-ai-agent-tool.vercel.app/',
    live: "https://hamza-ai-chatbot-nextjs.vercel.app/",
    // imageUrl: '/projects/chatbot/1.png',
    thumbnails: [
      "/projects/chatbot/1.png",
      "/projects/chatbot/2.png",
      "/projects/chatbot/3.png",
      "/projects/chatbot/4.png",
      "/projects/chatbot/5.png",
      "/projects/chatbot/pricing.png",
    ],
    techs: [
      {
        name: "NextJs",
        icon: SiNextdotjs,
      },
      {
        name: "OpenAi",
        icon: SiOpenai,
      },
      {
        name: "Langchain",
        icon: SiLangchain,
      },
    ],
    github: "https://github.com/hamzaMissewi/ai-chatbot-nextjs-wxflows-17-01",
    videoUrl:
      "https://drive.google.com/file/d/18fRBsO8fX_QymsBSqOX5IgIDDW9oHk6v/view",
  },
  {
    title: "Disney Kids App",
    createdAt: new Date(2025, 4, 1),
    category: ProjectCategory.next_js_application,
    icon: TbBrandDisney,
    status: "Active",
    description:
      "A web application to show disney movies and series for kids with recommendations feature with AI",
    live: "https://hamza-disney-kids-ai-app.vercel.app",
    // imageUrl: '/projects/disney/1.png',
    thumbnails: ["/projects/disney/1.png", "/projects/disney/2.png"],
    techs: [
      {
        name: "NextJs",
        icon: SiNextdotjs,
      },
      {
        name: "OpenAi",
        icon: SiOpenai,
      },
      {
        name: "Tmdb",
        icon: BiMovie,
      },
    ],
    github: "#",
  },
  {
    title: "Financial Dashboard - Real-time Crypto & Stock Market Data",
    createdAt: new Date(2025, 6, 15),
    category: ProjectCategory.next_js_application,
    icon: SiBitcoin,
    status: "Active",
    description:
      "Track cryptocurrency prices, stock market data, and convert currencies in real-time with interactive charts and live updates. Keys: cryptocurrency, bitcoin, ethereum, stock market, currency converter, financial dashboard, real-time data",
    live: "https://hamza-crypto-finance-converter-dash.vercel.app/",
    // imageUrl: '/projects/finance/1.png',
    thumbnails: [
      "/projects/finance/1.png",
      "/projects/finance/2.png",
      "/projects/finance/3.png",
    ],
    techs: [
      {
        name: "NextJs",
        icon: SiNextdotjs,
      },
      {
        name: "OpenAi",
        icon: SiOpenai,
      },
      {
        name: "Finance",
        icon: ChartLine,
      },
      {
        name: "CoinBase",
        icon: BiBitcoin,
      },
    ],
    github: "#",
  },
  {
    // id: 20
    title: "Restaurant POS Admin App",
    description:
      "A Next.js-powered POS system with dynamic menu management, real-time order processing, integrated payment handling, table/staff management, and detailed sales analytics.",
    icon: IoRestaurant,
    // imageUrl: '/projects/pso_restau/1.png',
    thumbnails: ["/projects/pso_restau/1.png"],
    featured: false,
    github: "",
    live: "https://hamza-restaurant-pos-admin.vercel.app",
    techs: [
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "NextJs",
        icon: RiNextjsFill,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
      {
        name: "Shadcn",
        icon: SiShadcnui,
      },
    ],
    status: "In Progress",
    createdAt: new Date(2024, 4, 1),
  },
  {
    title: "Bookings App",
    description:
      "A Bookings App for Organized Travels, Hajj and Umrah with Chatbot and Management System.",
    icon: TbBrandBooking,
    thumbnails: [
      "/projects/bookings/1.png",
      "/projects/bookings/2.png",
      "/projects/bookings/3.png",
      "/projects/bookings/4.png",
      "/projects/bookings/5.png",
      "/projects/bookings/6.png",
      "/projects/bookings/7.png",
    ],
    featured: false,
    github: "#",
    live: "https://hamza-go-makkah.vercel.app",
    techs: [
      {
        name: "Typescript",
        icon: BiLogoTypescript,
      },
      {
        name: "NextJs",
        icon: RiNextjsFill,
      },
      {
        name: "Tailwindcss",
        icon: SiTailwindcss,
      },
      {
        name: "Open AI",
        icon: SiOpenai,
      },
      {
        name: "Shadcn",
        icon: SiShadcnui,
      },
    ],
    status: "Active",
    createdAt: new Date(2025, 9, 1),
  },
];

export const b2bAliveWork = {
  title: "Full-Stack Web Developer, B2B Alive Ltd, London England",
  date: "Jan 2022 – December 2024",
  description: `Contributed to the development and maintenance of a highly interactive Digital Signage application that facilitates the management and dynamic distribution of multimedia content across screen networks. 
    - it allows clients in different organizations tomodify and display the visual content and broadcast composed scenes on different players, sharing information with the public, news,event posters. 
  - Frontend: Creation of dynamic interfaces utilizing React, TypeScript, and MUI to construct components while ensuring a seamless and contemporary user experience.
  - Backend design and development utilizing TypeScript, Node.js/KoaJs, and GraphQL API to orchestrate content management for a network of LED screens indoor and outdoor.
  Orchestration of a series of asynchronous tasks for media processing utilizing BullMQ and locking mechanisms to establish a distributed system through RedisLock for multi-tenant player requests.
  - Implementation of search engines (Algolia, Elasticsearch) and integration of artificial intelligence (OpenAI, Gemini) for multimedia processing.
  Utilized media provider APIs to enable the client to manage and search for images and videos, including Shutterstock and Adobe Stock. 
  - Cloud & DevOps: Administration and processing of visual content utilizing multi-cloud platform services (AWS, GCP, Azure), employing serverless solutions with Cloudflare Workers, and containerization through Docker, alongside automated CI/CD pipelines utilizing AWS CodePipeline and immutable deployments.
  - Task management: Asynchronous tasks coordinated through BullMQ and distributed locking mechanisms implemented via RedisLock.
  Facilitating real-time communication among various modules and services through buses utilizing Redis PubSub.
  - Security and Authentication: The establishment of a secure framework that incorporates Jwt, user role management utilizing CASL, SSO, and fingerprint authentication, alongside device-sensitive cookies and MFA tracking for thousands of users, guarantees stateless session management through Json web tokens.
  - Performance Optimization: Employing DataLoader in conjunction with GraphQL to address the N+1 batch query issue for multiple database queries, implementing a paging system, caching player details using Redis, facilitating full-text search through Elasticsearch, and instituting rate limiting, culminating in a 25% decrease in API response time.
  - Key Technologies: JavaScript, TypeScript, React, Node.js, MongoDB, GraphQL, Apollo (Client, Server), Amazon Web Services, Google Cloud Platform, Microsoft Azure, Material-UI, Context API, Redis, BullMQ, Elasticsearch, Algolia, Media API Providers (Adobe Stock, Shutterstock, Pexels, Pixabay, Bing), Casl, Cookies, Docker, WebSocket, Jest.`,
};

// export type SkillListType = Record<
//   | "typescript"
//   | "javascript"
//   | "react"
//   | "nextjs"
//   | "redis"
//   | "bullmq"
//   | "docker"
//   | "elasticsearch"
//   | "css3"
//   | "html5"
//   | "aws"
//   | "aws_lambda"
//   | "google_cloud"
//   | "azure"
//   | "koajs"
//   | "nodejs"
//   | "expressjs"
//   | "graphql"
//   | "graphql_apollo"
//   | "mongo_db"
//   | "python",
//   { name: string; url?: string; icon?: IconType }
// >;

export const certificationsNew = [
  "Hackerrank certifications (Rest, Golang, Python, React, Rest Api, Sql) | Issued 2025",
  "Cisco Data Analytics & Intro to Cybersecurity | Issued 2025",
  "Databricks Gen AI App Dev, ML At Scale | Issued 2025",
  "HashGraph Developer | Issued 2025",
  "AWS Generative AI, Lambda Foundations, Cost SaaS | Issued 2025",
  "FreeCodeCamp Responsive Web Design | Issued 2024",
  "AWS Academy Cloud Foundations | Issued 2022",
  "Cisco CCNA 1 & 2 | Issued 2021",
];

// const certifications: { title: string; description: string, date?: string }[] = [
//   {
//     title: 'CCNA 1 and 2',
//     description:
//       'Cisco Certified Network Associate (CCNA) - Routing and Switching',
//     date: 'Issued 2021'
//   },
//   {
//     title: 'AWS Academy',
//     description: 'AWS Academy Cloud Foundations Certification',
//     date: 'Issued 2021'
//   },
//   {
//     title: 'Responsive Web Design',
//     description: 'FreeCodeCamp Responsive Web Design Certification',
//     date: 'Issued 2024'
//   }
// ]

export const certifications: { title: string; description: string }[] = [
  {
    title: "HackerRank Certifications",
    description:
      "Hackerrank certifications (Rest, Golang, Python, React, Rest Api, Sql) | Issued 2025",
  },
  {
    title: "AWS Cloud Practitioner",
    description: "AWS Cloud Practitioner Certification | Issued 2025",
  },
  {
    title: "AWS Generative AI, Lambda Foundations, Cost SaaS",
    description:
      "AWS Generative AI, Lambda Foundations, Cost SaaS Certification | Issued 2025",
  },
  {
    title: "Cisco Data Analytics & Intro to Cybersecurity",
    description: "Cisco Data Analytics & Intro to Cybersecurity | Issued 2025",
  },
  {
    title: "CCNA 1 and 2",
    description:
      "Cisco Certified Network Associate (CCNA) - Routing and Switching | Issued 2021",
  },
  {
    title: "AWS Academy",
    description: "AWS Academy Cloud Foundations Certification | Issued 2022",
  },
  {
    title: "Responsive Web Design",
    description:
      "FreeCodeCamp Responsive Web Design Certification | Issued 2024",
  },
];

// Resume download link
export const RESUME_EN_LINK =
  "https://drive.google.com/file/d/12SGJUM81niMkpc1o28gbIR9YjjK7Hsvp/view?usp=sharing";
// 'https://drive.google.com/file/d/1U-7S15-kqIybdb1jjYdHC_tD1bpGid8s/view?usp=sharing';
// 'https://drive.google.com/file/d/1Sz-sCuRh3d-_bVgG1Y-YYAKMHi3mTwjW/view?usp=sharing';

export const RESUME_FR_LINK =
  "https://drive.google.com/file/d/1_fzCMeagCYRlhFoE4pZ9VrYg0kUFpH8Q/view?usp=sharing";
export const RESUME_AR_LINK =
  "https://drive.google.com/file/d/18HbjBrED1LnTy1yOZxKdMVydnk3pwmG1/view?usp=sharing";

export const skillCategoriesOld = [
  {
    title: "Frontend",
    skills: [
      { name: "React/Next.js", level: 95 },
      { name: "TypeScript", level: 90 },
      { name: "Tailwind CSS", level: 92 },
      { name: "Mui", level: 92 },
      { name: "Vue.js", level: 40 },
      { name: "Angular", level: 60 },
    ],
  },
  {
    title: "Backend",
    skills: [
      { name: "Node.js (Koa.Js, Express.Js)", level: 88 },
      { name: "Python", level: 85 },
      { name: "PostgreSQL", level: 82 },
      { name: "MongoDB", level: 80 },
    ],
  },
  {
    title: "Databases",
    skills: [
      { name: "MongoDb", level: 90 },
      { name: "PostgreSql", level: 90 },
    ],
  },
  {
    title: "API Tools",
    skills: [
      { name: "GraphQL", level: 88 },
      { name: "Rest", level: 90 },
      { name: "tRPC", level: 50 },
    ],
  },
  {
    title: "DevOps & Cloud",
    skills: [
      { name: "AWS", level: 85 },
      { name: "Azure", level: 85 },
      { name: "GCP", level: 85 },
      { name: "Docker", level: 88 },
      { name: "Nginx", level: 82 },
      { name: "CI/CD", level: 80 },
    ],
  },
];

// export const entreprises = {
//     b2b_alive: {
//         title: 'B2b Alive Ltd',
//         link: 'https://www.b2b-alive.com',
//         logo: '/images/logos/b2b-alive.png',
//     },
//     globalnet_3s: {
//         title: 'Globalnet 3S Group',
//         link: 'https://www.3s.com.tn/groupe-3s-tunisie/',
//         logo: 'https://www.3s.com.tn/wp-content/uploads/2016/12/logo.png',
//     },
// };

export const personalLinks = {
  github: "https://github.com/hamzaMissewi",
  hackerrank: "https://www.hackerrank.com/profile/hamza_missaoui47",
  linkedin: "https://linkedin.com/in/hamza-missewi",
  notion:
    "https://www.notion.so/hamza-missaoui/Hamza-M-Engineer-25bba7e86dab8067b6d9d183e6cfeb67",
  portfolio: "https://hamza-portfolio-3.vercel.app",
  b2bAlive: "https://www2.b2b-alive.com/fr/accueil",
  stackoverflow: "https://stackoverflow.com/users/30839893/hamza",
  devto: "https://dev.to/hamza_fd6852f2d0d306891ea",
  calendly: "https://calendly.com/hamza-missaoui28",
  x: "https://x.com/Hamza471525",
};
